<template>
  <div class="home_center">
    <home-header :isShow="true" activeIndex="1"></home-header>
    <!-- banner部分 -->
    <div class="block banner">
      <el-carousel>
        <el-carousel-item v-for="(item,index) in bannerList" :key="index">
          <a :href="item.url" target="_blank"><img :src="item.img" width="100%" height="100%"></a>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- nrca开始 -->
    <!-- <index-nrca :activity_nrca="activity_nrca"></index-nrca> -->


    <!-- <hold-activity></hold-activity> -->



    <div class="activityBox">
      <router-link class="more" to="/activity/undefined">更多>></router-link>
      <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">

        <el-tab-pane label="本馆活动" name="first">
          <!-- 活动列表开始 -->
          <div v-if='dataEmptyOwn'>
            <index-list :list-val="listDataOwn"></index-list>
            <pagination :listNum="listNumOwn" :getList="getList"></pagination>
          </div>
          <data-empty v-else></data-empty>
        </el-tab-pane>

        <el-tab-pane label="全部活动" name="second">
          <!-- <div class="hdnum">
            <label></label>
            「共{{listNum}}场活动」
            <el-input class="search" :value="keywords" v-model="keywords" placeholder="请输入活动名称 机构名称(主办方 参赛机构)"></el-input>
            <el-button icon="el-icon-search" type="primary"  @click="SearchActivity"></el-button>
         </div>
         <div class="hdlabel">
           <div class="lx">
             <el-link disabled :underline="false">类型：</el-link>
             <el-link v-for="v in searchData.type" :underline="false" v-if="v.code==type" type="success">{{v.name}}</el-link>
             <el-link :underline="false" v-else @click="getType(v.code)">{{v.name}}</el-link>
           </div>
           <div class="lx">
             <el-link disabled :underline="false">状态：</el-link>
             <el-link v-for="v in searchData.status" :underline="false" v-if="v.code==status" type="success">{{v.name}}</el-link>
             <el-link v-else @click="getStatus(v.code)" :underline="false">{{v.name}}</el-link>
           </div>
           <div class="sf">
             <el-link class="sfLabel" disabled :underline="false">省份：</el-link>
             <div class="sfBox">
                <el-link v-for="v in searchData.province" :underline="false" v-if="v.code==province" type="success">{{v.name}}</el-link>
                <el-link v-else @click="getProvince(v.code)" :underline="false">{{v.name}}</el-link>
             </div>
           </div>
         </div> -->

          <!-- 活动列表开始 -->
          <div v-if='dataEmpty'>
            <index-list :list-val="listData"></index-list>
            <!-- <Pagination :listNum="listNum" :getList="getList"></Pagination> -->
          </div>
          <data-empty v-else></data-empty>

        </el-tab-pane>

      </el-tabs>

    </div>

    <!-- 活跃举办方开始 -->
    <organ-index></organ-index>

    <home-footer></home-footer>
  </div>
</template>
<script>
  import HomeHeader from '@/components/Header'
  import HomeFooter from '@/components/Footer'
  import IndexNrca from './components/Nrca'
  import IndexList from './components/Lists'
  import Pagination from '@/components/Pagination'
  import DataEmpty from '@/components/Data'
  import HoldActivity from './components/holdActivity'
  import OrganIndex from './components/Organize'
  export default {
      name: 'Index',
      components:{
        HomeHeader,
        HomeFooter,
        IndexNrca,
        IndexList,
        Pagination,
        DataEmpty,
        HoldActivity,
        OrganIndex
      },
      data () {
        return {
            // banH:650,
            page:1,
            page_size:6,
            pageOwn:1,
            page_sizeOwn:12,
            type:'',
            status:'',
            province:'',
            keywords:'',
            listNum:0,
            listNumOwn:0,
            activity_nrca:{},
            searchData:{},
            listData:{},
            listDataOwn:{},
            bannerList:[],
            dataEmpty:true,
            dataEmptyOwn:true,
            activeName: 'second',
            group:'pc'
       };
      },
      created(){
        this.getUrl()
        this.getOgranId()
      },
      methods: {
          getUrl(){
              let url = this.$route.query.redirect
              console.log(url)
              this.$router.push({
                  path: url,
              });
          },
          getOgranId(){
              let ogran_id = this.$route.params.id
              if(ogran_id){
                  localStorage.setItem('ogran_id',ogran_id)
                  this.$data.activeName = 'first'
                  console.log( localStorage.getItem('ogran_id'))
              }
          },
          getType(type){
              this.$data.type = type
              this.getList(this.$data.page,this.$data.page_size)
          },
          getStatus(status){
              this.$data.status = status
              this.getList(this.$data.page,this.$data.page_size)
          },
          getProvince(province){
              this.$data.province = province
              this.getList(this.$data.page,this.$data.page_size)
          },
          getSearch(){
              var data = {
                  type:this.$data.type,
                  status:this.$data.status,
                  province:this.$data.province,
              }
              this.$api.activitySearch(data).then(res => {
                  //数据处理
                  this.$data.searchData = res.data
              }).catch(err => console.log(err))
          },
          SearchActivity(){
           if(this.keywords == ''){
             this.$message('请输入搜索关键词')
             return
           }
            this.getList(this.$data.page,this.$data.page_size)
            this.keywords = "";
          },
          getList(page,page_size){
              if(this.activeName ==  "first"){
                var data = {
                    group:this.group,
                    page:page,
                    page_size:page_size,
                    organ_id:localStorage.getItem('ogran_id')
                  }
                  this.$api.activityOwn(data).then(res => {
                    //数据处理
                    if(res.data.activity_list == ''){
                          this.dataEmptyOwn = false
                        }else{
                          this.dataEmptyOwn = true
                        }
                      this.$data.activity_nrca = res.data.activity_nrca
                        this.$data.listDataOwn = res.data.activity_list
                        this.$data.listNumOwn = res.data.activity_num
                  }).catch(err => console.log(err))

              }else{
                var data = {
                  keywords:this.$data.keywords,
                  status:this.$data.status,
                  type:this.$data.type,
                  province:this.$data.province,
                  page:page,
                  page_size:page_size,
              }
              this.$api.activityList(data).then(res => {
                  //数据处理
                  if(res.data.activity_list == ''){
                    this.dataEmpty = false
                  }else{
                    this.dataEmpty = true
                  }
                  this.$data.activity_nrca = res.data.activity_nrca
                  this.$data.listData = res.data.activity_list
                  this.$data.listNum = res.data.activity_num
              }).catch(err => console.log(err))
              }


          },
          getBanner(){
              this.$api.bannerList().then(res => {
                  //数据处理
                  this.$data.bannerList = res.data
              }).catch(err => console.log(err))
          },

          getOwnActivity(page,page_size){


          },
          handleClick(activeName) {
            if(activeName ==  "first"){
              this.getList(this.$data.pageOwn,this.$data.page_sizeOwn)
            }else{
              this.getList(this.$data.page,this.$data.page_size)
            }
          }
      },

      mounted:function(){
          if(localStorage.getItem('ogran_id')){
              this.$data.activeName = 'first'
          }
          this.getSearch();
          this.getList(this.$data.page,this.$data.page_size)
          this.getBanner();
      }
    }

</script>
<style scoped>
  .home_center{
    height: auto;
    background: #EAEAEA;
  }
  /* banner部分 */
  .el-carousel__container{
      height: 650px !important;
  }

  .el-carousel__item h3{
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n){
     background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1){
     background-color: #d3dce6;
  }
  .search{
    width: 350px;
    margin-right: 20px;
  }
  /* 活动数量标题 */
  .hdnum{
    width: 1200px;
    margin: 30px auto;
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #58B75B;
  }
  .hdnum label{
    display: inline-table;
    width: 10px;
    height: 21px;
    background: #FFB463;
    border-radius: 5px;
    margin-right: 20px;
  }
  .hdlabel{
    width: 1201px;
    background: #FFFFFF;
    border-radius: 10px;
    margin: 0 auto 20px auto;
    display: flex;
    padding: 0px 10px 20px 10px;
    box-sizing: border-box;
    flex-direction: column;
  }
  .lx{
    border-bottom: 1px dotted #EAEAEA;
  }
  .hdlabel div{
    height: auto;
  }
  .hdlabel .lx>.el-link{
    margin-right: 20px;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .hdlabel .sf .el-link{
    margin-right: 20px;
    margin-top: 20px;
  }
  .el-tabs{
    width: 1200px;
    margin:20px auto 0px  auto;
  }
  .sfBox{
    display: inline-block;
    width: 1100px;
  }
  .lx , .sf{
    display: flex;
    align-items:flex-start;
  }

  .el-tabs >>> .el-tabs__item {
    width: 130px !important;
    height: 55px !important;
    font-size: 24px !important;
    font-family: Microsoft YaHei !important;
    font-weight: bold !important;
    color: #999;
    margin: 0 auto !important;
  }

  .el-tabs >>>  .is-active {
      color: #58B75B!important;
  }
  .el-tabs >>> .el-tabs__active-bar{
    display: block;
    width: 90px !important;
    height: 4px !important;
    background: #FFB463;
    border-radius: 2px;
    margin: 0px auto 0px auto !important;
  }
  .el-tabs >>> .el-tabs__header{
    margin: 0px;
  }

  .activityBox{
    width: 1200px;
    margin: 0 auto;
    position: relative;
    height: auto;
  }


  .activityBox >>> .more{
    position: absolute;
    right: 0px;
    top: 10px;
    font-size: 14px;
    z-index: 10;
    color: #999999;
    /* top: -10px; */
  }




  /* .el-tabs >>> .el-link{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 26px;
  } */


  .sfBox{
    display: inline-block;
    width: 1100px;
  }
  .lx , .sf{
    display: flex;
    align-items: flex-start;
  }


</style>




// WEBPACK FOOTER //
// src/index/index.vue